import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, makeObservable } from "mobx";
export let UIMode = /*#__PURE__*/function (UIMode) {
  UIMode[UIMode["Difference"] = 0] = "Difference";
  return UIMode;
}({});
/**
 * A mode for interacting with the map.
 */
let MapInteractionMode = (_class = class MapInteractionMode {
  constructor(options) {
    var _options$buttonText, _options$uiMode, _options$invisible;
    _defineProperty(this, "onCancel", void 0);
    _defineProperty(this, "buttonText", void 0);
    _defineProperty(this, "uiMode", void 0);
    _defineProperty(this, "invisible", void 0);
    _initializerDefineProperty(this, "customUi", _descriptor, this);
    _initializerDefineProperty(this, "message", _descriptor2, this);
    _initializerDefineProperty(this, "messageAsNode", _descriptor3, this);
    _initializerDefineProperty(this, "pickedFeatures", _descriptor4, this);
    _defineProperty(this, "onEnable", void 0);
    makeObservable(this);
    /**
     * Gets or sets a callback that is invoked when the user cancels the interaction mode.  If this property is undefined,
     * the interaction mode cannot be canceled.
     */
    this.onCancel = options.onCancel;

    /**
     * Gets or sets the details of a custom user interface for this map interaction mode. This property is not used by
     * the `MapInteractionMode` itself, so it can be anything that is suitable for the user interface. In the standard
     * React-based user interface included with TerriaJS, this property is a function that is called with no parameters
     * and is expected to return a React component.
     */
    this.customUi = options.customUi;

    /**
     * Gets or sets the html formatted message displayed on the map when in this mode.
     */
    this.message = function () {
      return options.message;
    };

    /**
     * Gets or sets the react node displayed on the map when in this mode.
     */
    this.messageAsNode = function () {
      return options.messageAsNode;
    };

    /**
     * Set the text of the button for the dialog the message is displayed on.
     */
    this.buttonText = (_options$buttonText = options.buttonText) !== null && _options$buttonText !== void 0 ? _options$buttonText : "Cancel";

    /**
     * Gets or sets the features that are currently picked.
     */
    this.pickedFeatures = undefined;

    /**
     * Gets or sets whether to use the diff tool UI+styles
     */
    this.uiMode = (_options$uiMode = options.uiMode) !== null && _options$uiMode !== void 0 ? _options$uiMode : undefined;

    /**
     * Determines whether a rectangle will be requested from the user rather than a set of pickedFeatures.
     */
    // this.drawRectangle = options.drawRectangle ?? false;
    this.onEnable = options.onEnable;
    this.invisible = (_options$invisible = options.invisible) !== null && _options$invisible !== void 0 ? _options$invisible : false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "customUi", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "message", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "messageAsNode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pickedFeatures", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MapInteractionMode as default };